<script>
import { EventPresenceElementMixin } from "%/dynamic-component-editor/standard-components/event-card/event-presence-element-mixin";
import TextElement from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";
import { describeStatus, toPhaseRow } from "%/dynamic-component-editor/helpers/event-join-card";
import eventPhase from "%/dynamic-component-editor/helpers/event-phase";

export default {
  name: "EventStatus",
  elementPanelSettings: {
    displayIcon: "info-circle",
    elementGroup: "eventElements",
    elementType: "element",
    displayName: "Event Status",
  },
  extends: TextElement,
  mixins: [EventPresenceElementMixin],
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      const state = eventPhase.resolve(toPhaseRow(this.entity), this.countdownNow);

      return describeStatus(state, {
        isLivestream: this.isLivestreamEvent,
        presence: this.eventPresence,
      });
    },
  },
};
</script>
